export enum AuthType {
  Unauthorized,
  User,
  Company,
  // Carries the minted onboarding session. Everything after the BankID gate.
  Onboarding,
  // Anonymous, but scoped to an invite link: carries the InviteToken and nothing
  // else. Only Core's onboarding BankID endpoints use it, and only until the
  // session exists — after that the wizard moves to Onboarding above.
  OnboardingInvite,
  // Carries the person session that a BankID login without an invite yields. Used only to ask for
  // a company session; everything after that is Onboarding above.
  OnboardingPerson,
  // Anonymous apart from the offboarding material link's token, for Core's offboarding BankID.
  OffboardingLink,
  // Carries the offboarding material session from that BankID login.
  Offboarding,
}

export enum LoginMethod {
  USERNAME_PASSWORD = "USERNAME_PASSWORD",
  TICKET = "TICKET",
  BANKID_DESKTOP = "BANKID_DESKTOP",
  QR_CODE = "QR_CODE",
}

export enum LoginResult {
  Success = 0,
  WrongUsernameOrPassword = 1,
  AccountLocked = 2,
  NoCompanies = 3,
  Timeout = 4,
  UnknownBankIdError = 5,
  IncorrectPersonalNumber = 6,
  ForceLoginWithBankId = 7,
}

export enum PersonCompanyRelationType {
  VD = 1,
  CEO = 2,
  Contact = 4,
  Employee = 8,
  Documents = 16,
  IncomingInvoicesOverview = 32,
  IncomingInvoices = 8192,
  InvoicesAdmin = 128,
  Invoices = 1024,
  ReceiptsAdmin = 512,
  Receipts = 2048,
  Admin = 256,
  Reports = 4096,
  IncomingInvoicesAdmin = 64,
  IncomingInvoicesSignee = 16384,
  Revisor = 32768,
  Agreement = 65536,
  CashReconciliation = 131072,
  PaymentFileSignee = 262144,
  MissingDocumentAdmin = 524288,
  SalaryFileSignee = 1048576,
  ReceiptPayoutFileSignee = 2097152,
  Auditor = 4194304, // read-only superkoll role for wint employees.
  SalaryAdmin = 8388608,
  BookingAdmin = 1 << 24,
  PaymentSignee = 1 << 25,
  BookingAdminAPI = 1 << 26,
  UploadGenericDocuments = 1 << 28,
  Advisor = 1 << 29,
  DeviationAdmin = 1 << 30,
  Board = 2147483648,
  IncomingInvoicesCertifyAdmin = 4294967296,
}

export enum LoginView {
  BankIdApp,
  UserNamePassword,
  ForgotPassword,
}
